import React from 'react';
import FormField from './FormField';
import CheckBoxItemListForm from './CheckBoxItemListForm';
import { useLanguage } from '../../context/LanguageContext';

interface Props {
    value: any;
    itemDict: any;
    setFieldValue: (item: any) => void;
    disabled: boolean;
}

const CheckBoxItemDictForm: React.FC<Props> = ({
    value,
    itemDict,
    setFieldValue = null,
    disabled = false,
}) => {
    const { currentLanguage } = useLanguage();

    return (
        <>
            {Object.keys(itemDict).map((key, index) => (
                <CheckBoxItemListForm
                    key={index}
                    title={itemDict[key]?.name[currentLanguage]}
                    tableList={itemDict[key]?.items}
                    value={value}
                    setFieldValue={setFieldValue}
                    disabled={disabled}
                />
            ))}
        </>
    );
};

export default FormField(CheckBoxItemDictForm);
